import { Helmet } from "react-helmet-async";
import { Grid, Container, Typography } from "@mui/material";
import { AppWidgetSummary } from "../sections/@dashboard/app";
import WithAuth from "../components/WithAuth";
import Popup from "../components/Popup";
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { dashboard } from "../store/dashboardSlice";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { bgStyles } from "../utils/cssStyles";
import { useNavigate } from "react-router-dom";
import { fetchDashboardData } from "../store/dasboardDataSlice";

function DashboardAppPage() {
  const [responseData, setResponseData] = useState("");
  const [flag, setFlag] = useState(false);
  const [sessionResponse, setSessionResponse] = useState("");
  const [sessionFlag, setSessionFlag] = useState(false);
  const [timeoutFlag, setTimeoutFlag] = useState(false);
  const [cache, setCache] = useState({ data: null, timestamp: 0 });

  // const dispatch = useDispatch();

  // const { data } = useSelector((state) => state.dashboard);
  const { emailData, emailStatus } = useSelector((state) => state.email);

  const theme = useTheme();
  const isBelow768 = useMediaQuery(theme.breakpoints.down("sm"));

  // useEffect(() => {
  //   dispatch(dashboard());
  // }, [dispatch]);

  const navigate = useNavigate();
  const handleSessionClose = () => {
    setSessionFlag(false);
    navigate("/login");
    // console.log("================== TESt")
  }

  // const [tickets, setTickets] = useState({
  //   all_ticket: null,
  //   prog_ticket: null,
  //   todo_ticket: null,
  //   hold_ticket: null,
  //   test_ticket: null,
  //   done_ticket: null,
  //   delivered_ticket: null
  // });

  // useEffect(() => {
  //   const fetchData = async () => {
  //     const controller = new AbortController();
  //     const timeoutId = setTimeout(() => controller.abort(), 20000);

  //     try {
  //       const response = await fetch('/meonsupport/dashboard_data', {
  //         signal: controller.signal,
  //       });
        
  //       const data = await response.json();
        
  //       if (data.msg === "Logged out") {
  //         setSessionResponse("Session expired. Please login again.");
  //         setSessionFlag(true);
  //       } else {
  //         setTickets(data);
  //       }
  //     } catch (error) {
  //       if (error.name === "AbortError") {
  //         setTimeoutFlag(true);
  //       } 
  //     } finally {
  //       clearTimeout(timeoutId);
  //     }
  //   };

  //   fetchData();
  // }, []);

  const dispatch = useDispatch();
  const {
    tickets,
    session_response,
    session_flag,
    timeout_flag,
    loading,
    error
  } = useSelector((state) => state.dashboardData);

  useEffect(() => {
    dispatch(fetchDashboardData());
  }, [dispatch]);

  useEffect(() => {
    if (tickets) {
      if (session_flag) {
        setSessionResponse(session_response);
        setSessionFlag(true);
      }
      if (timeout_flag) {
        setTimeoutFlag(true);
      }
    }
  }, [tickets]);

  const {
    all_ticket,
    done_ticket,
    delivered_ticket,
    prog_ticket,
    todo_ticket,
    test_ticket,
    hold_ticket,
  } = tickets;
  
  const handleClose = () => {
    setFlag(false);
    window.location.replace("/");
  };

  const handleTimeoutClose = () => {
    setTimeoutFlag(false);
    window.location.reload();
  };

  if (emailStatus === "loading") {
    return <div style={bgStyles}></div>;
  }

  return (
    <>
      <Helmet>
        <title> Dashboard | Support Tool </title>
      </Helmet>
      <Container maxWidth="xl" sx={{ marginBottom: 4 }}>
        <Typography
          className="productName"
          sx={{ display: isBelow768 ? "" : "none", mb: 2 }}
          color={"black"}
          variant="h6"
        >
          {emailData[1]}
        </Typography>
        <Grid container spacing={isBelow768 ? 2 : 3}>
          <Grid item xs={6} sm={6} md={3}>
            <AppWidgetSummary
              title="Total Tickets"
              total={all_ticket}
              icon={"mdi:ticket-outline"}
              color="purple"
            />
          </Grid>
          <Grid item xs={6} sm={6} md={3}>
            <AppWidgetSummary
              title="Open Tickets"
              total={todo_ticket}
              color="error"
              icon={"bx:bxs-error"}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={3}>
            <AppWidgetSummary
              title="Inprogress Tickets"
              total={prog_ticket}
              color="warning"
              icon={"bx:bxs-time-five"}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={3}>
            <AppWidgetSummary
              title="Closed Tickets"
              total={done_ticket}
              color="greye"
              icon={"bx:bxs-check-circle"}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={3}>
            <AppWidgetSummary
              title="Resolved Tickets"
              total={delivered_ticket}
              color="success"
              icon={"bx:bxs-badge-check"}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={3}>
            <AppWidgetSummary
              title="On Hold Tickets"
              total={hold_ticket}
              color="error"
              icon={"bx:bxs-error"}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={3}>
            <AppWidgetSummary
              title="Testing Tickets"
              total={test_ticket}
              color="warning"
              icon={"bx:bxs-time-five"}
            />
          </Grid>
        </Grid>
      </Container>
      <Popup flag={flag} handleClose={handleClose} response={responseData} />
      <Popup response={sessionResponse} flag={sessionFlag} handleClose={handleSessionClose} />
      <Popup response="Request timed out. Please refresh the page." flag={timeoutFlag} handleClose={handleTimeoutClose} />
    </>
  );
}

export default WithAuth(DashboardAppPage);